import { PushAction } from 'redux-little-router';
import { Epic, ofType } from 'redux-observable';
import { EMPTY, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Action } from '../../actions';
import { changeLocation } from '../../actions/common';
import {
    UPDATE_IMPORT_EXPORT_WIZARD_VISIBILITY,
    UpdateImportExportWizardVisibility
} from '../../actions/importExportWizard/updateImportExportWizardVisibility';
import { ResetImportWizard, resetImportWizardAction } from '../../actions/importWizard/resetImportWizard';
import { EpicDeps } from '../../service/StoreFactory';
import { UrlHelpers } from '../../service/UrlHelpers';
import { EXCEL_WIZARD_PREFIX, TOOLS_PREFIX } from '../../typings/common';
import { ImportExportWizardMode } from '../../typings/importExportWizard';
import { State } from '../../typings/state';

type EpicActions = PushAction | ResetImportWizard;

export const updateImportExportWizardVisibilityEpic: Epic<Action, Action, State, EpicDeps> = (action$, store) => {
    return action$.pipe(
        ofType(UPDATE_IMPORT_EXPORT_WIZARD_VISIBILITY),
        mergeMap(
            (action: UpdateImportExportWizardVisibility): Observable<EpicActions> => {
                const state = store.value;

                if (action.isVisible) {
                    return of(
                        changeLocation(UrlHelpers.createNewDirectUrlPathByParams(TOOLS_PREFIX, EXCEL_WIZARD_PREFIX))
                    );
                }

                switch (state.importExportWizard.wizardMode) {
                    case ImportExportWizardMode.IMPORT:
                        return of(
                            changeLocation(UrlHelpers.createNewDirectUrlPathByParams(TOOLS_PREFIX)),
                            resetImportWizardAction()
                        );
                    case ImportExportWizardMode.EXPORT:
                        return of(changeLocation(UrlHelpers.createNewDirectUrlPathByParams(TOOLS_PREFIX)));
                    default:
                        return EMPTY;
                }
            }
        )
    );
};
